import { configureStore } from '@reduxjs/toolkit'
import userReducer from "./userSlice";
import tokenReducer from "./tokenSlice";
import electiveCourseReducer from "./electiveCoursesSlice";

const store = configureStore({
    reducer: {
        userReducer: userReducer,
        tokenReducer: tokenReducer,
        electiveCourseReducer: electiveCourseReducer,
    },
})
export type RootState = ReturnType<typeof store.getState>
export type RootDispatch = typeof store.dispatch

export default store